export const ZOHO_PHASE_ONE = "@ZOHO/PHASE_ONE";
export const ZOHO_PHASE_TWO = "@ZOHO/PHASE_TWO";
export const ZOHO_PHASE_THREE = "@ZOHO/PHASE_THREE";
export const ZOHO_PHASE_FOUR = "@ZOHO/PHASE_FOUR";
export const ZOHO_PHASE_ONE_DONE = "@ZOHO/PHASE_ONE_DONE";
export const ZOHO_PHASE_TWO_DONE = "@ZOHO/PHASE_TWO_DONE";
export const ZOHO_PHASE_THREE_DONE = "@ZOHO/PHASE_THREE_DONE";
export const ZOHO_PHASE_FOUR_DONE = "@ZOHO/PHASE_FOUR_DONE";
export const ZOHO_PHASE_FILE = "@ZOHO/PHASE_FILE";
export const ZOHO_PHASE_EXTRA_FILE = "@ZOHO/PHASE_EXTRA_FILE";
export const ZOHO_PHASE_FILE_DONE = "@ZOHO/PHASE_FILE_DONE";
export const ZOHO_PHASE_EXTRA_FILE_DONE = "@ZOHO/PHASE_EXTRA_FILE_DONE";
